import * as Sentry from "@sentry/nextjs";

Sentry.init({
  environment: process.env.NODE_ENV,
  dsn: "https://41a01f62af8a4093bc2a9f962877bf4b@o210004.ingest.sentry.io/6270369",
  tracesSampleRate: 0.0,
});
